import { motion } from "framer-motion";
import { fadeUp } from "@/lib/animations";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  center?: boolean;
  className?: string;
  white?: boolean;
}

export default function SectionTitle({
  title,
  subtitle,
  center = true,
  className = "",
  white = false,
}: SectionTitleProps) {
  return (
    <div className={`${center ? 'text-center' : ''} mb-16 ${className}`}>
      <motion.h2 
        className={`text-3xl md:text-4xl font-bold mb-4 ${white ? 'text-white' : 'text-purple-600'}`}
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
      >
        {title}
      </motion.h2>
      
      <motion.div 
        className="w-20 h-1 bg-green-500 mx-auto mb-8"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        custom={1}
        viewport={{ once: true, margin: "-50px" }}
      />
      
      {subtitle && (
        <motion.p 
          className={`text-lg max-w-2xl mx-auto ${white ? 'text-gray-200' : 'text-gray-700'}`}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          custom={2}
          viewport={{ once: true, margin: "-50px" }}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
